






















































import { Component } from "vue-property-decorator";
import { EventWidgetComponent } from "../EventWidget";
import selectComponent from "../../../components/SelectComponentNew/index.vue";

import { current } from "@szgc/plt-core-v2";
import MagicValidator from "../../../magic/MagicValidator.vue";

@Component({
  name: "CorpSelectSingleWidget",
  components: {
    selectComponent,
    MagicValidator
  }
})
export default class CorpSelectSingleWidget
  extends EventWidgetComponent
  implements App.PuttedWidgetComponent, App.LinkedWidgetComponent, App.PutAbleWidgetComponent
{
  private show: boolean = false;
  private list: any[] = [];

  putModel: any = {};
  params: App.LinkedWidgetComponentParam[] = [];

  initText() {
    if (this.status === "mine") {
      if (this.value) {
        const ext = Array.isArray(this.widget.ext) ? this.widget.ext : [this.widget.ext];
        this.widget.text = ext.map((i: any) => i.corpName).join("、");
        return false;
      }
      const { field } = this.defaultValue;
      if (["corpName", "corpId"].includes(field)) {
        this.widget.text = (current as any).corpName;
        this.value = current.corpId;

        this.$nextTick(() => {
          this.putModel = { corpId: this.value, corpName: this.widget.text };
          this.handleEvent(this.value);
        });
      }
      return false;
    }
    if (this.value) {
      const ext = Array.isArray(this.widget.ext) ? this.widget.ext : [this.widget.ext];
      this.widget.text = ext.map((i: any) => i.corpName).join("、");
    }
  }

  reset() {
    this.widget.text = "";
    this.value = "";

    this.putModel = { corpId: this.value, corpName: this.widget.text };
    this.handleEvent(this.value);
  }

  refresh(option: App.LinkEventOption) {
    this.params = [
      {
        key: option.property,
        value: option.value
      }
    ];

    this.reset();
  }

  setValue(value: string) {
    // this.reset();

    if (!/[0-9]+/.test(value)) {
      this.value = "";
      this.widget.text = "";
    } else {
      this.value = value.split(",")[0];
      this.widget.text = value.split(",")[1];
    }

    this.putModel = { corpId: this.value, corpName: this.widget.text };
    this.handleEvent(this.value);
  }

  confirm(data: any) {
    // if (!data.source.length) return false;
    this.widget.ext = data.source;
    const item = data.source[0];
    this.putModel = item;
    this.handleEvent(this.value);
  }

  async created() {
    this.initText();
  }
  async showHandler() {
    if (!this.widget.readonly) {
      this.show = true;
    }
  }
}
